<div class="flex-column">
  <div class="flex-row-lt-sm-column">
    <div class="flex-column flex-13 flex-lt-sm-100">
      <p class="forecast-heading">
        {{'dashboard.predictedBehavior' | translate}}
      </p>
      @if (calculatedCPI) {
      <div class="kpi-wrapper flex-lt-sm-mrgbtn12px">
        <h4 class="kpi-name">CPI</h4>
        <span class="label is-outline {{'label-' | kpiLabel:calculatedCPI}}">Q{{calculatedCPI}}</span>
      </div>
      }
    </div>
    <div class="flex-row-lt-sm-column forecast-wrapper">
      <div class="form-field-group flex-50 flex-lt-sm-100">
        <div class="flex-column">
          <mat-button-toggle-group [value]="selectedReferenceType" (change)="selectedReferenceTypeChanged($event)">
            <mat-button-toggle [value]="REF_BATCH" class="small-font-size label-padding flex-50">{{ 'reports.reportTable.batch' | translate }}</mat-button-toggle>
            <mat-button-toggle [value]="RETAIN_MEASUREMENT" class="small-font-size label-padding flex-50">{{ 'reports.filterLabel.measurement' | translate }}</mat-button-toggle>
          </mat-button-toggle-group>
          @if (selectedReferenceType === REF_BATCH) {
          <mat-form-field appearance="fill">
            <mat-label class="select-label small-font-size">{{'dashboard.selectRefCharge' | translate }}</mat-label>
            <mat-select class="small-font-size"
                    name="forecast_{{batch.batchId}}"
                    [(ngModel)]="selectedReference"
                    [disabled]="isLoading"
                    (selectionChange)="selectedReferenceChanged($event)"
                    id="forecast_{{batch.batchId}}">
              @for (option of referenceBatches; track optionIndex; let optionIndex = $index) {
                <mat-option [value]="option">{{option.batchNumber}}</mat-option>
              }
            </mat-select>
            @if (selectedReference) {
            <button mat-icon-button matSuffix aria-label="Clear"
                    (click)="resetSelectedReference(); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
            }
          </mat-form-field>
          } @else if (selectedReferenceType === RETAIN_MEASUREMENT) {
          <mat-form-field appearance="fill">
            <mat-label class="select-label small-font-size">{{'dashboard.selectRefMeasurement' | translate }}</mat-label>
            <mat-select class="small-font-size"
              name="forecast_retain_select_{{batch.batchId}}"
              [(ngModel)]="selectedRetainMeasurement"
              [disabled]="isLoading"
              (selectionChange)="selectedRetainMeasurementChanged($event)"
              id="forecast_retain_select_{{batch.batchId}}">
              @for (option of retainMeasurements; track option) {
              <mat-option [colimoMultiLineTooltip]="option.metaSummary" [value]="option">
                {{ option.info }}
              </mat-option>
              }
            </mat-select>
            @if (selectedRetainMeasurement) {
            <button mat-icon-button matSuffix aria-label="Clear"
                    (click)="selectedRetainMeasurementChanged(null); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
            }
          </mat-form-field>
          }
        </div>
      </div>
      <div class="flex-30 flex-lt-sm-100 button-centered">
        <button class="btn btn-link"
                (click)="onSubmit()"
                [disabled]="isLoading">
          @if (calculatedCPI) {
            <span>{{'missing.calcAgain' | translate}}</span>
          } @else {
            <span>{{'dashboard.calcForecast' | translate}}</span>
          }
        </button>
      </div>
      <div class="flex-20 flex-lt-sm-100 button-centered">
        @if (showVectorTintingButton) {
        <button class="vector-tinting-button"
                mat-icon-button
                matTooltip="{{ 'dashboard.vectorTinting' | translate }}"
                [matTooltipPosition]="'above'"
                (click)="navigateToVectorTintingPage()">
          <img alt="vectorTinting" src="assets/icon/vector_100x100.png"/>
        </button>
        }
      </div>
    </div>
  </div>
  <div class="forecast-ref-info"><span class="forecast-ref-label">{{ 'reports.reportTable.batch' | translate }}:</span> {{ selectedReference?.batchNumber }}</div>
  <div class="forecast-ref-info"><span class="forecast-ref-label">{{ 'reports.filterLabel.measurement' | translate }}:</span> {{ selectedRetainMeasurement?.info }}</div>
</div>
@if (isLoading) {
  <colimo-loader [background]="'transparent'" [top]="'50%'"></colimo-loader>
}
